/*
 * DownloadCenterv3
*/

export class DownloadCenterv3 {
  private el:NodeList;

  constructor(downloadCenterElement:string) {
    this.el = document.querySelectorAll(downloadCenterElement);
  }

  /**
   * Init app
   * @returns false if app element not found
   */
  public init() {
    if (!this.el || this.el.length === 0) {
      return;
    }

    this.el.forEach((downloadCenter:HTMLElement) => {
      if (downloadCenter) {
        this.activateApp(downloadCenter);
      }
    })
  }

  /**
   * Activate app (launch element listeners for buttons and selects and render app)
   */
  private activateApp(downloadCenter:HTMLElement) {
    this.elementListeners(downloadCenter);
  }

  /**
   * Set listeners for specific elements
   */
  private elementListeners(downloadCenter:HTMLElement) {
    let searchSelects = downloadCenter.querySelectorAll('.js-v3-app-download-center-search-select');
    searchSelects.forEach((searchSelect:HTMLSelectElement) => {
      searchSelect.addEventListener('change', (e) => {
        let select = e.currentTarget as HTMLSelectElement;
        this.filterLists({ key: select.name, value: select.value, downloadCenter })
      });
    });

    const materialSearchInputs = downloadCenter.querySelector('.v3-app-download-center__material_search_input') as HTMLInputElement
    if (materialSearchInputs) {
      materialSearchInputs.addEventListener('keyup', this.filterMaterials)
    }
  }


  /**
   * Filter materials by keyword search
   * @param {Event} event
   *
   */
  private filterMaterials( event: Event):void {
    const target = event.target as HTMLInputElement
    const targetValue = target.value || ''
    const searchReg = new RegExp(targetValue.toString().replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '').toUpperCase()) // remove specia characters
    const materials = document.querySelectorAll<HTMLElement>('.js-v3-app-download-center-search-material')
    materials.forEach( material => {
      const searchData = material.dataset?.material
      const title = JSON.parse(searchData).title.toUpperCase()
      const description = JSON.parse(searchData).description.toUpperCase()
      const show = searchReg.test(title) || searchReg.test(description)
      if (show) {
       material.classList.remove('hidden')
      } else {
       material.classList.add('hidden')
      }
    })
  }

  /**
   * Filter list based on search parameters
   * @param params search parameters
   */
  private filterLists(params = { key: null, value: null, downloadCenter: null }) {
    let items = params.downloadCenter?.querySelectorAll('.js-v3-app-download-center-search-item');
    let materials = params.downloadCenter?.querySelectorAll('.js-v3-app-download-center-search-material');

    let oldParams = JSON.parse(params.downloadCenter?.getAttribute('data-params'));
    let newParams = {...oldParams, [params.key]: params.value};

    for (const key in newParams) {
      if (newParams[key] === '') {
        delete newParams[key];
      }
    }

    params.downloadCenter?.setAttribute('data-params', JSON.stringify(newParams));

    materials.forEach((material) => {
      if (newParams) {
        material.classList.add('hidden');
        let materialData = JSON.parse(material.getAttribute('data-material')) || null;
        if (materialData) {
          let keys = Object.keys(newParams);
          const hasAllKeys = keys.every(item => materialData.hasOwnProperty(item));
          if (hasAllKeys) {
            if (keys.every(item => materialData[item].includes(newParams[item]))) {
              material.classList.remove('hidden');
            }
          }
        }
      } else {
        material.classList.remove('hidden');
      }
    });

    items.forEach((item) => {
      item.classList.remove('hidden');
      let mats = item.querySelectorAll('.js-v3-app-download-center-search-material');
      let hiddenMats = item.querySelectorAll('.js-v3-app-download-center-search-material.hidden');
      if (mats.length === hiddenMats.length) {
        item.classList.add('hidden');
      }
    })
  }
}
